"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _parseToRgb = _interopRequireDefault(require("polished/lib/color/parseToRgb"));

var _base = _interopRequireDefault(require("./base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AZUREISH_WHITE = (0, _parseToRgb.default)('#D4EEFE');
var SEA_BLUE = (0, _parseToRgb.default)('#005D97');
var VIVID_CERULEAN = (0, _parseToRgb.default)('#009EFF');
var DARK_SPRING_GREEN = (0, _parseToRgb.default)('#107748');
var GREEN_CRAYOLA = (0, _parseToRgb.default)('#11BC6E');
var AERO_BLUE = (0, _parseToRgb.default)('#CCF6E0');
var GAMBOGE_ORANGE = (0, _parseToRgb.default)('#8F5C00');
var ORANGE_WEB = (0, _parseToRgb.default)('#FFA300');
var BLANCHED_ALMOND = (0, _parseToRgb.default)('#FFEBC8');
var RED_BROWN = (0, _parseToRgb.default)('#A8292A');
var CORAL_RED = (0, _parseToRgb.default)('#FF4142');
var MISTY_ROSE = (0, _parseToRgb.default)('#FFDFDF');
var status = {
  information: {
    light: _objectSpread({}, AZUREISH_WHITE, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, VIVID_CERULEAN, {
      fg: _base.default.snowWhite
    }),
    dark: _objectSpread({}, SEA_BLUE, {
      fg: _base.default.snowWhite
    })
  },
  success: {
    light: _objectSpread({}, AERO_BLUE, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, GREEN_CRAYOLA, {
      fg: _base.default.snowWhite
    }),
    dark: _objectSpread({}, DARK_SPRING_GREEN, {
      fg: _base.default.snowWhite
    })
  },
  warning: {
    light: _objectSpread({}, BLANCHED_ALMOND, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, ORANGE_WEB, {
      fg: _base.default.snowWhite
    }),
    dark: _objectSpread({}, GAMBOGE_ORANGE, {
      fg: _base.default.snowWhite
    })
  },
  danger: {
    light: _objectSpread({}, MISTY_ROSE, {
      fg: _base.default.charcoal
    }),
    medium: _objectSpread({}, CORAL_RED, {
      fg: _base.default.snowWhite
    }),
    dark: _objectSpread({}, RED_BROWN, {
      fg: _base.default.snowWhite
    })
  }
};
var _default = status;
exports.default = _default;